import React from 'react';
import { connect } from 'react-redux';

import { FillInBlankResponsesManager } from './fillInBlankResponsesManager';

import { ActionTypes } from '../../actions/actionTypes';
import * as filterActions from '../../actions/filters';
import * as massEdit from '../../actions/massEdit';
import * as questionActions from '../../actions/questions';
import { deleteResponse, getGradedResponsesWithCallback, submitResponseEdit } from '../../actions/responses';
import { rematchFillInBlankResponse } from '../../libs/grading/fillInBlankRematching';

interface FillInBlankResponsesManagerWrapperProps {
  admin?: boolean;
  concepts?: any;
  conceptsFeedback?: any;
  dispatch: Function;
  fillInBlank?: any;
  filters?: any;
  massEdit?: any;
  match?: any;
  mode?: string;
  question?: any;
  questionID?: string;
  responses?: any;
  states?: any;
}

const FillInBlankResponsesManagerWrapper: React.FC<FillInBlankResponsesManagerWrapperProps> = (props) => {
  const { dispatch, fillInBlank, match, question: propQuestion, questionID, } = props;

  const questionIDToUse = questionID || match?.params?.questionID;

  const question = propQuestion || (fillInBlank?.data?.[questionIDToUse]);

  if (!question || !questionIDToUse) {
    return <div>Loading question...</div>;
  }

  // Custom rematch function for fill-in-blank questions
  const rematchOne = (response: any, mode: string, questionData: any, qid: string, callback: Function, dispatchArg?: Function) => {
    rematchFillInBlankResponse(response, questionData, qid, callback);
  };

  return (
    <FillInBlankResponsesManager
      {...props}
      Constants={ActionTypes}
      deleteResponse={deleteResponse}
      filterActions={filterActions}
      getGradedResponsesWithCallback={getGradedResponsesWithCallback}
      massEditActions={massEdit}
      question={question}
      questionActions={questionActions}
      questionID={questionIDToUse}
      rematchOne={rematchOne}
      storeResponsesLocally={false}
      submitResponseEdit={submitResponseEdit}
    />
  );
};

function select(state: any) {
  return {
    concepts: state.concepts,
    conceptsFeedback: state.conceptsFeedback,
    fillInBlank: state.fillInBlank,
    filters: state.filters,
    massEdit: state.massEdit,
  };
}

export default connect(select)(FillInBlankResponsesManagerWrapper);
